import { useEffect } from "react";

function getFulfillmentOptions(location) {
  if (!location) {
    return [];
  }

  return [
    location.accepts_pickup ? { label: "Pickup", value: "pickup" } : null,
    location.accepts_delivery ? { label: "Delivery", value: "delivery" } : null,
  ].filter(Boolean);
}

function FulfillmentSelector({ fulfillmentType, location, onChange }) {
  const options = getFulfillmentOptions(location);

  useEffect(() => {
    const hasValidSelection = options.some((option) => option.value === fulfillmentType);

    if (options.length && !hasValidSelection) {
      onChange(options[0].value);
    }
  }, [fulfillmentType, onChange, options]);

  if (!location) {
    return null;
  }

  if (!options.length) {
    return (
      <div className="fulfillment-selector fulfillment-selector--blocked">
        <strong>This location is not currently accepting orders.</strong>
      </div>
    );
  }

  return (
    <fieldset className="fulfillment-selector">
      <legend>How would you like your order?</legend>

      <div className="fulfillment-options">
        {options.map((option) => {
          const isActive = fulfillmentType === option.value;

          return (
            <label
              aria-checked={isActive}
              className={isActive ? "fulfillment-option active" : "fulfillment-option"}
              key={option.value}
            >
              <input
                checked={isActive}
                name="fulfillment_type"
                type="radio"
                value={option.value}
                onChange={(event) => onChange(event.target.value)}
              />
              <span>{option.label}</span>
            </label>
          );
        })}
      </div>
    </fieldset>
  );
}

export { getFulfillmentOptions };
export default FulfillmentSelector;
